export type EnumValues<T> = T[keyof T];
